import { render, staticRenderFns } from "./shortYoutube.vue?vue&type=template&id=64b28608&"
import script from "./shortYoutube.vue?vue&type=script&lang=js&"
export * from "./shortYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports